import React, { createContext, useContext, useState } from 'react';
import ReactModal from 'react-modal';
import cn from 'classnames';
import styles from './Modal.module.scss';

ReactModal.setAppElement('.container');

const ModalContext = createContext({});

function Title({ children, className }) {
  return (
    <div className={cn(className)}>{children}</div>
  );
}

function Close({ className, children, onClick }) {
  const { close } = useContext(ModalContext);

  const closeHandler = () => {
    if(onClick) onClick();
    if (close) close();
  };

  return (
    <button className={className} onClick={closeHandler} type="button">
      {children}
    </button>
  );
}

function Trigger({ children, onClick, ...rest }) {
  const { open } = useContext(ModalContext);

  const openHandler = () => {
    open();
    if (onClick) onClick();
  };

  return (
    <button onClick={openHandler} type="button" {...rest}>
      {children}
    </button>
  );
}

function Content({ children, className = '', isOpen: isOpenManual = null }) {
  const { isOpen } = useContext(ModalContext);

  const isOpenState = isOpenManual !== null ? isOpenManual : isOpen;

  return (
    <ReactModal
      className={cn(styles.content, className)}
      isOpen={isOpenState}
      overlayClassName={styles.overlay}
    >
      {children}
    </ReactModal>
  );
}

const ModalWrapper = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);
  const open = () => setIsOpen(true);

  return (
    <ModalContext.Provider value={{ close, isOpen, open }}>
      {children}
    </ModalContext.Provider>
  );
};

ModalWrapper.Content = Content;
ModalWrapper.Close = Close;
ModalWrapper.Title = Title;
ModalWrapper.Trigger = Trigger;

export default ModalWrapper;
